import React, { useRef, useState } from "react";

import { AddIcon, CrossIcon, TickIcon } from "assets/icons";

import { ButtonPrimary, ButtonSecondary } from "../Button";
import { Label } from "../formControls";
import { AddButton, Form, FormFooter, Header, ItemCount, ItemListInputWrapper } from "./styled";

interface WithNewItemLineProps {
  addItemAllowed: boolean;
  className?: string;
  id: string;
  itemCount?: number;
  label: string;
  required?: boolean;
  children: React.ReactNode;
  submitDisabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  renderNewItemInputs: () => React.ReactNode;
}
export const WithNewItemLine = (props: WithNewItemLineProps) => {
  const {
    addItemAllowed,
    className,
    id,
    itemCount,
    label,
    required,
    children,
    submitDisabled,
    onCancel,
    onSubmit,
    renderNewItemInputs,
  } = props;
  const openNewItemButtonRef = useRef<HTMLButtonElement | null>(null);
  const [newItemFormVisible, setNewItemFormVisible] = useState(false);

  const handleCancel = () => {
    setNewItemFormVisible(false);
    onCancel();
  };

  return (
    <ItemListInputWrapper className={className}>
      <Header data-testid="WithNewItemLine_header">
        <Label inputId={id} label={label} required={required} />
        {itemCount !== undefined && <ItemCount>{itemCount}</ItemCount>}
        {addItemAllowed && (
          <AddButton
            type="button"
            ref={openNewItemButtonRef}
            title={"Add new item"}
            onClick={() => setNewItemFormVisible(true)}
          >
            <AddIcon aria-hidden={true} />
          </AddButton>
        )}
      </Header>
      <div id={id}>
        {children}
        {newItemFormVisible && (
          <NewItemForm
            submitDisabled={submitDisabled}
            onCancel={handleCancel}
            onSubmit={onSubmit}
            renderNewItemInputs={renderNewItemInputs}
          />
        )}
      </div>
    </ItemListInputWrapper>
  );
};

interface NewItemFormProps {
  submitDisabled: boolean;
  onCancel: () => void;
  onSubmit: () => void;
  renderNewItemInputs: () => React.ReactNode;
}
const NewItemForm = (props: NewItemFormProps) => {
  const { submitDisabled, onCancel, onSubmit, renderNewItemInputs } = props;

  const submit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Form onSubmit={(e) => submit(e)}>
      {renderNewItemInputs()}
      <FormFooter>
        <ButtonPrimary title={"Add"} disabled={submitDisabled}>
          <TickIcon />
        </ButtonPrimary>
        <ButtonSecondary type="button" title={"Cancel"} onClick={onCancel}>
          <CrossIcon />
        </ButtonSecondary>
      </FormFooter>
    </Form>
  );
};
